var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPsUserAvatarDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1256B541-E076-4B3C-9DF2-0870FB98DEF9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 12,
    cy: 12,
    r: 12
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "02_PS_Header",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02_PS_Layout_Side-Expanded",
    transform: "translate(-1318.000000, -20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Top-Nav-bar",
    transform: "translate(64.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Right-Nav",
    transform: "translate(1214.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-28-Copy-4",
    transform: "translate(40.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PS_UserAvatar"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Oval",
    fill: "#A6DBFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.040000, 2.880000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.24465116,4.38650395 C4.24465116,4.38650395 7.47711628,3.84637473 8.66904698,2.53697057 C9.74637209,1.34213927 9.73022348,0 9.73022348,0",
    id: "Stroke-600",
    stroke: "#2150B7",
    strokeWidth: 0.654702082,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.62404651,0.491026561 C7.62404651,0.491026561 8.34237209,3.24093898 6.69348837,5.04136971",
    id: "Stroke-602",
    stroke: "#2150B7",
    strokeWidth: 0.654702082,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.17106977,1.80043073 C6.17106977,1.80043073 6.48125581,2.79901508 6.04046512,3.73196554",
    id: "Stroke-604",
    stroke: "#2150B7",
    strokeWidth: 0.654702082,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6846599,19.4027565 C8.6846599,19.4027565 11.1113856,18.5301107 10.3747872,18.744292 C9.91016367,18.879391 9.40159926,19.0458587 8.97852037,19.2295165 C8.03163665,19.6387053 8.09693897,20.8824756 8.79893897,21.3081956 C9.50093897,21.7501195 12.4068925,21.8154261 13.3536129,20.6369623 C15.1659157,18.6237534 12.0967064,13.1244196 12.0967064,13.1244196 C12.0967064,13.1244196 11.3620553,12.5024526 8.6846599,12.1585704 C6.02359014,11.8150154 3.49312502,13.4845057 3.49312502,13.4845057 C3.49312502,13.4845057 1.92570595,14.679337 0.782915254,18.5910183 C-0.0333638162,21.3735022 3.26456688,21.1445201 3.26456688,21.1445201 C3.26456688,21.1445201 4.29291525,22.8465818 6.28479944,22.7974792 C8.70082223,22.7485402 9.97438083,22.3229839 10.8396366,21.6355467 C9.62419173,21.5876761 8.88159901,21.4240006 8.61185847,21.1445201 C8.40271529,20.927825 8.42698243,20.3472372 8.6846599,19.4027565 Z",
    id: "Fill-624",
    stroke: "none",
    fill: "#91D5FF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8862879,14.3653276 C12.8862879,14.3653276 13.816846,12.7449399 12.9842413,12.1557081 C12.1351479,11.5501086 12.4781483,11.6154152 12.2659158,10.9445092 C11.8414506,9.91335343 10.617032,9.70057526 10.617032,9.70057526 C10.617032,9.70057526 9.14772972,9.60220627 7.92331111,9.70057526 C6.69889251,9.79878057 4.56024135,10.6989959 4.56024135,10.6989959 C4.56024135,10.6989959 1.91549716,12.6467346 4.18475297,13.6451553 C5.29489251,14.6434123 6.02954367,15.7238344 6.02954367,15.7238344 C6.02954367,15.7238344 10.6007065,12.2375458 12.2659158,13.1703326 L12.8862879,14.3653276 Z",
    id: "Fill-626",
    stroke: "none",
    fill: "#43BCFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.6358324,6.54702082 C11.2274603,7.39813352 10.2479254,3.76453697 10.2479254,3.76453697 C10.2479254,3.76453697 9.97039054,3.99351902 0.142390536,7.70911701 C-0.951423418,10.1642498 4.61559984,10.2460876 4.61559984,10.2460876 L4.43601844,12.7012204 L6.01959984,14.8290022 C6.01959984,14.8290022 7.20654545,13.5774009 8.58039312,12.5217158 C9.37935179,11.9077839 10.3803669,11.3612804 10.8846231,11.1626705 L9.39899519,6.61232735",
    id: "Fill-628",
    stroke: "none",
    fill: "#D7F0FF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2479254,3.76453697 C10.2479254,3.76453697 9.97039054,3.99351902 0.142390536,7.70911701 C-0.951423418,10.1642498 4.61559984,10.2460876 4.61559984,10.2460876 L4.43601844,12.7012204 L6.00009024,14.886937 C7.05978413,13.7460915 7.95981636,12.9036192 8.70018695,12.3595201 C9.44055753,11.8154209 10.2367572,11.4113306 11.0887861,11.1472489 L9.48156565,6.54607786 C9.87344042,6.2032148 10.1016041,5.93604537 10.1660567,5.74456958 C10.5060743,4.73444468 10.2479254,3.76453697 10.2479254,3.76453697 Z",
    id: "Stroke-702",
    stroke: "none",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.6358324,6.54702082 C11.2274603,7.39813352 10.2479254,3.76453697 10.2479254,3.76453697 C10.2479254,3.76453697 9.97039054,3.99351902 0.142390536,7.70911701 C-0.951423418,10.1642498 4.61559984,10.2460876 4.61559984,10.2460876 L4.43601844,12.7012204",
    id: "Stroke-702",
    stroke: "#2150B7",
    strokeWidth: 0.5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3299535,11.1299354 C9.22395349,11.2283044 5.95883721,14.9272075 5.95883721,14.9272075 L4.24465116,12.5048098",
    id: "Stroke-704",
    stroke: "#2150B7",
    strokeWidth: 0.5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.56024135,10.8025844 C4.56024135,10.8025844 1.91549716,12.750323 4.18475297,13.7487437 C5.50712507,15.0255765 6.02954367,15.8274228 6.02954367,15.8274228 C6.02954367,15.8274228 10.7313111,11.8664752 12.7556832,13.2742484",
    id: "Stroke-706",
    stroke: "#2150B7",
    strokeWidth: 0.5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.46413471,13.4213927 C3.46413471,13.4213927 1.78259983,14.5836525 0.7540882,18.5280689 C0.0522514562,21.228715 3.23573983,21.0815707 3.23573983,21.0815707",
    id: "Stroke-708",
    stroke: "#2150B7",
    strokeWidth: 0.5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.79581395,18.2344922 C1.79581395,18.2344922 3.18348837,17.7762007 3.73855814,19.265648",
    id: "Stroke-710",
    stroke: "#2150B7",
    strokeWidth: 0.5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-712",
    stroke: "none",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    points: "5.06093023 17.0222541 7.9015814 17.0222541 7.44462837 21.8015793 5.53437209 21.8015793"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-714",
    stroke: "#2150B7",
    strokeWidth: 0.5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "5.06093023 17.0222541 7.9015814 17.0222541 7.44462837 21.8015793 5.53437209 21.8015793"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.90181395,
    y1: 16.367552,
    x2: 3.75488372,
    y2: 19.28114,
    id: "Stroke-716",
    stroke: "#2150B7",
    strokeWidth: 0.5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7970068,20.6669319 C1.7970068,20.6669319 1.73186773,19.783084 2.56430913,19.455733 C3.88668122,18.9483389 5.16023982,19.8811257 5.19272773,20.9777517 C5.22537889,22.0907452 4.1642161,21.9436009 3.77256541,21.7471903 C3.3805882,21.5671472 3.26630913,21.0106504 2.77654169,21.1086921 C2.30326308,21.2232649 1.84598355,21.2232649 1.7970068,20.6669319",
    id: "Fill-744",
    stroke: "none",
    fill: "#E6F7FF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7970068,20.6669319 C1.7970068,20.6669319 1.73186773,19.783084 2.56430913,19.455733 C3.88668122,18.9483389 5.16023982,19.8811257 5.19272773,20.9777517 C5.22537889,22.0907452 4.1642161,21.9436009 3.77256541,21.7471903 C3.3805882,21.5671472 3.26630913,21.0106504 2.77654169,21.1086921 C2.30326308,21.2232649 1.84598355,21.2232649 1.7970068,20.6669319 Z",
    id: "Stroke-746",
    stroke: "#2150B7",
    strokeWidth: 0.5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.06093023,7.36539842 C5.06093023,7.54544149 4.914,7.69274946 4.7344186,7.69274946 C4.55467395,7.69274946 4.40790698,7.54544149 4.40790698,7.36539842 C4.40790698,7.18519167 4.55467395,7.03804738 4.7344186,7.03804738 C4.914,7.03804738 5.06093023,7.1689878 5.06093023,7.36539842",
    id: "Fill-756",
    stroke: "none",
    fill: "#2150B7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.58883721,
    y1: 6.6233453,
    x2: 11.030376,
    y2: 11.0923775,
    id: "Stroke-758",
    stroke: "#2150B7",
    strokeWidth: 0.5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1530175,13.2577172 C12.1530175,13.2577172 15.2222268,18.6590093 13.4100873,20.6723819 C12.4632036,21.850682 9.55741333,21.7688442 8.85541333,21.3432879 C8.15325007,20.901364 8.088111,19.6737976 9.03483147,19.2646088 C10.144971,18.7735822 11.794018,18.4300273 11.794018,18.4300273",
    id: "Stroke-760",
    stroke: "#2150B7",
    strokeWidth: 0.5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.7422326,
    y1: 18.6590093,
    x2: 10.6116279,
    y2: 16.8585786,
    id: "Stroke-762",
    stroke: "#2150B7",
    strokeWidth: 0.5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6116279,9.82053123 C10.6116279,9.82053123 11.8525353,10.0334731 12.2606749,11.0646289 C12.4727442,11.7193309 12.1462326,11.6702283 12.9788372,12.275664 C13.8277674,12.8812635 12.8808837,14.3870782 12.8808837,14.3870782",
    id: "Stroke-764",
    stroke: "#2150B7",
    strokeWidth: 0.5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.452332,19.3790179 L7.71768084,18.9863604 C7.71768084,18.9863604 8.09333247,19.804738 6.24837851,19.9027796 C5.49740177,19.9355147 5.41577386,21.2612864 6.80344828,21.5722699 C8.87696037,22.0143575 9.79102967,20.3119684 8.452332,19.3790179",
    id: "Fill-766",
    stroke: "none",
    fill: "#E6F7FF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.452332,19.3790179 L7.71768084,18.9863604 C7.71768084,18.9863604 8.09333247,19.804738 6.24837851,19.9027796 C5.49740177,19.9355147 5.41577386,21.2612864 6.80344828,21.5722699 C8.87696037,22.0143575 9.79102967,20.3119684 8.452332,19.3790179 Z",
    id: "Stroke-768",
    stroke: "#2150B7",
    strokeWidth: 0.5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPsUserAvatarDefault);
export default __webpack_public_path__ + "static/media/PS_UserAvatarDefault.f6448e712fc91c47eeff76e8b3964fe7.svg";
export { ForwardRef as ReactComponent };